import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { ref as v, onMounted as h, onUnmounted as m } from "vue";
const s = "LivePreviewUpdated", g = (a, d) => {
  const n = v({
    ...a
  }), w = (t, o) => {
    console.debug("fetching live preview data: ", t), fetch(t).then((e) => {
      if (!e.ok) throw new Error("Network response was not ok");
      return e.json();
    }).then((e) => o(e)).catch((e) => console.error(e));
  }, i = (t) => {
    var e;
    const o = (e = t == null ? void 0 : t.detail) == null ? void 0 : e.hashId;
    if (o) {
      const r = d(), l = r.split("?")[0], c = new URLSearchParams(r.split("?")[1] || "");
      c.set("live_preview", o), w(l.concat("?", c), (p) => {
        n.value = {
          ...n.value,
          ...p
        };
      });
    }
  };
  return h(() => {
    window.document.getElementById("cs-live-preview") && (console.log("Watching for live preview updates"), window.addEventListener(s, i));
  }), m(() => {
    window.document.getElementById("cs-live-preview") && window.removeEventListener(s, i);
  }), {
    content: n
  };
};
export {
  s as LIVE_PREVIEW_UPDATED,
  g as useDynamicContent
};
